import { Context } from '@obvio/app'

import { SignSection, Layout, SingleSection } from './SignLayout/components'
import { FadeIn } from '@/components/FadeIn'

import type { ReactElement } from 'react'

type SignLayoutProps = {
  children: ReactElement
}

export function SignLayout({ children }: SignLayoutProps): ReactElement {
  return (
    <Context name="sign" render="div">
      <SignSection>
        <Layout>
          <FadeIn>
            <SingleSection $content>{children}</SingleSection>
          </FadeIn>
        </Layout>
      </SignSection>
    </Context>
  )
}
